export const DEFAULT_QUERY_KEY_SORT = 'sort'
export const DEFAULT_PAGE_NUMBER_QUERY_KEY = 'page'
export const pageSize = 15
